module.exports = __webpack_public_path__ + "static/media/dutch.fd430bb3.png";